import type { AdvisorMovementKind } from "@/types";

export interface MovementMeta {
  label: string;
  icon: string;
  badge: string;
}

export const MOVEMENT_META: Record<AdvisorMovementKind, MovementMeta> = {
  consignacion: {
    label: "Consignación",
    icon: "ri-hand-heart-line",
    badge: "bg-secondary-500/20 text-secondary-200",
  },
  compra: {
    label: "Compra del asesor",
    icon: "ri-shopping-bag-3-line",
    badge: "bg-primary-500/25 text-primary-100",
  },
  venta: {
    label: "Venta a cliente",
    icon: "ri-checkbox-circle-line",
    badge: "bg-accent-500/20 text-accent-200",
  },
  pago: {
    label: "Abono / pago",
    icon: "ri-hand-coin-line",
    badge: "bg-accent-500/15 text-accent-100",
  },
  fee: {
    label: "Fee logístico",
    icon: "ri-truck-line",
    badge: "bg-secondary-500/20 text-secondary-200",
  },
  devolucion: {
    label: "Devolución",
    icon: "ri-arrow-go-back-line",
    badge: "bg-background-300/40 text-foreground-700",
  },
};